import styled from "styled-components";

export const MaxWidthContainer = ({ children, className }) => {
  return <Wrapper className={className}>{children}</Wrapper>;
};

const Wrapper = styled.div`
  width: 100%;
  max-width: 1700px;
  margin: 0 auto;
`;
